import { useCallback, useEffect, useMemo, useState } from "react";
import { useEndDateValidations } from "./endDate";
import { useJobValidations } from "./job";
import { useLevelsValidations } from "./levels";
import { useLocationValidations } from "./location";
import { usePayCodeValidations } from "./payCode";
import { useDurationValidations } from "./duration";
import { useRateValidations } from "./rate";
import { useStartDateValidations } from "./startDate";
import { useTotalValidations } from "./total";
import { useNoteValidations } from "./note";

export const useValidationConfig = ({ user, type, timeOffPlans }) => {
  const startDate = useStartDateValidations();
  const endDate = useEndDateValidations();
  const rate = useRateValidations();
  const job = useJobValidations();
  const location = useLocationValidations();
  const payCode = usePayCodeValidations({ user, timeOffPlans });
  const duration = useDurationValidations({ user, timeOffPlans });
  const levels = useLevelsValidations();
  const total = useTotalValidations();
  const note = useNoteValidations(type);
  return useMemo(() => {
    return {
      startDate,
      endDate,
      rate,
      job,
      location,
      payCode,
      duration,
      ...levels,
      total,
      note,
    };
  }, [
    startDate,
    endDate,
    rate,
    job,
    location,
    payCode,
    duration,
    levels,
    total,
    note
  ]);
}

export const useValidations = (config, data, originalData) => {
  const [errors, setErrors] = useState({});

  const validate = useCallback((row, field, data, originalData) => {
    const value = row[field];
    if (!config[field]) {
      return null;
    }
    if (!Array.isArray(config[field])) {
      throw new Error("configuration error");
    }
    for (const validator of config[field]) {
      const error = validator(value, row, data, originalData);
      if (error) {
        return error;
      }
    }
  }, [config]);

  useEffect(() => {
    const errors = {};
    for (const row of data) {
      if (!row.isTouched) {
        errors[row.id] = null;
        continue;
      }
      const rowErrors = Object
        .keys(config)
        .reduce((total, field) => {
          const error = validate(row, field, data, originalData)
          total[field] = error;
          return total;
        }, {});
      errors[row.id] = rowErrors;
    }
    setErrors(errors);
  }, [data, originalData, config, validate]);

  return { errors, setErrors };
}
